import React, {useEffect} from 'react';
import ImgCheck from "@/shared/pictures/check.svg";
import {glueName} from "@/shared/utils/users";
import {useStore} from "@/app/providers/StoreProvider";
import {observer} from "mobx-react-lite";

export const ProfileUserWidget = observer(() => {

    const {userStore} = useStore();
    const { user } = userStore;
    useEffect(() => {
        const fetchData = async() =>{
            await userStore.initUser();
        }
        if(user.id == 0){
            fetchData();
        }
    }, []);
    return (
        <div className='profile'>
            <div className='profile_avatar'>
                <img src={user.photoUrl} alt="photo"  width={100} height={100}/>
            </div>
            <div className='profile_label'>
                <p className='profile_label-text'>OVI Club</p>
                <img className='profile_label-img' src={ImgCheck} alt="check" />
            </div>
            <div className='profile_info'>
                <h2 className='profile_info-title'>{glueName(user)}</h2>
                {/* <p className='profile_info-age'>25 лет</p> */}
            </div>
        </div>
    );
});

